import { render, staticRenderFns } from "./duolingxing.vue?vue&type=template&id=074ae289&scoped=true&"
import script from "./duolingxing.vue?vue&type=script&lang=js&"
export * from "./duolingxing.vue?vue&type=script&lang=js&"
import style0 from "./duolingxing.vue?vue&type=style&index=0&id=074ae289&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074ae289",
  null
  
)

export default component.exports